import { FC, memo } from "react";

import { ContentSidebar } from "../sidebar/ContentSidebar";
import { TopicSidebarPanel } from "../topic/TopicSidebarPanel";

import { PlannerSidebarPanel } from "components/materials/section/planner/PlannerSidebarPanel";
import { CoursePageSidebarPanel } from "components/materials/sidebar/SectionPageSidebarPanel";
import { useCapabilities } from "store/capability-hooks";
import { SCROLL_TRACKING_IDS } from "utils/hooks/use-scroll-restoration";

export type PageSidebarProps = {
  topicId: string;
  pageId: string;
};

export const PageSidebar: FC<PageSidebarProps> = memo(
  ({ topicId, pageId }) => {
    const { canAuthorCourse } = useCapabilities();

    return (
      <ContentSidebar
        AssignmentPanel={<CoursePageSidebarPanel pageCategory="assignment" />}
        context={pageId ? "page" : "course"}
        CourseResourcePanel={<CoursePageSidebarPanel pageCategory="course_resource" />}
        InstructorWorkspacePanel={
          canAuthorCourse && <CoursePageSidebarPanel pageCategory="instructor_workspace" />
        }
        pageId={pageId}
        PlannerPanel={<PlannerSidebarPanel scrollTrackingId={SCROLL_TRACKING_IDS.PAGE_SIDEBAR} />}
        scrollTrackingId={SCROLL_TRACKING_IDS.PAGE_SIDEBAR}
        TopicsPanel={
          <TopicSidebarPanel
            scrollTrackingId={SCROLL_TRACKING_IDS.PAGE_SIDEBAR}
            topicId={topicId}
          />
        }
      />
    );
  },
  (prevProps, nextProps) => prevProps.topicId === nextProps.topicId,
);

PageSidebar.displayName = "PageSidebar";
